import "../../../assets/scss/payment-modal-style.scss";
import React, { useState } from "react";
import { Modal } from "antd";
import { InstanceCardInterface } from "../../utility/interface/instance-card";
import { CloseOutlined, CopyOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useElapsedTime } from "../../hooks/useElapsedTime";
import { calculateTime } from "../../utility/common/common";
import { useAppSelector } from "../../store/hooks";
import { stopInstanceRent } from "../../server/Instances";

interface Props {
  visible: boolean;
  onClose: () => void;
  payment: InstanceCardInterface | null;
  instance: InstanceCardInterface | null;
  createdAt: string;
}

export const PaymentModal: React.FC<Props> = ({
  visible,
  onClose,
  payment,
  instance,
  createdAt,
}) => {
  const { t } = useTranslation();
  const settingsState = useAppSelector((state: any) => state.settings);
  const instanceState = useAppSelector((state: any) => state.instance);
  const [finalPayment, setFinalPayment] = useState(instance?.created_at!);
  const { calculateCost, diff } = useElapsedTime(createdAt);

  const [isPaying, setIsPaying] = useState(false);

  const pay = async () => {
    setIsPaying(true);
    try {
      const response = await stopInstanceRent(
        instanceState.instance_id,
        instanceState.host_id
      );
      const data = await response.data;
      console.log("data", data);
      onClose();
      window.location.reload(); // could be replaced by refetch for SPA feel
    } finally {
      setIsPaying(false);
    }
  };

  if (!instance) return null;

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={520}
      className="payment-modal"
    >
      <div className="modal-header">
        <h2>{instance?.product_name}</h2>
        <CloseOutlined onClick={onClose} className="close-icon" />
      </div>

      <div className="modal-body">
        <div className="detail-grid">
          <div>
            <span>{t("Applications")}</span>
            <strong>{instance?.template_name}</strong>
          </div>
          <div>
            <span>{t("GPU Amount")}</span>
            <strong>{instance?.gpu_count} GPU</strong>
          </div>
          <div>
            <span>{t("Cost")}</span>
            <strong>
              $
              {Number(Number(instance?.price) * instance?.gpu_count).toFixed(2)}{" "}
              / {t("hours")}
            </strong>
          </div>
          <div>
            <span>{t("Time Used")}</span>
            <strong>{calculateTime(diff / 1000, settingsState.lang)}</strong>
          </div>
        </div>

        <h3 style={{ marginTop: "1rem" }}>
          {t("Total Cost")}: $
          {(
            Number(calculateCost(diff, instance?.price)) * instance?.gpu_count
          ).toFixed(2)}
        </h3>
      </div>

      <div className="modal-footer">
        <button className="primary-btn" onClick={pay} disabled={isPaying}>
          {isPaying ? t("Processing...") : t("Pay")}
        </button>
      </div>
    </Modal>
  );
};
